module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-dialog-wrap"
  }, [_c('CvipDialog', {
    attrs: {
      "widthnew": '790px',
      "heightnew": '570px',
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.payNow()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("选择会员卡套餐：")]), _vm._v(" "), _c('ul', {
    staticClass: "card-list"
  }, _vm._l((_vm.cardData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "card",
      class: {
        active: item.type === _vm.chooseType
      },
      on: {
        "click": function($event) {
          return _vm.chooseCard(index, item.type)
        }
      }
    }, [(item.recommend) ? _c('div', {
      staticClass: "recommend-icon"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('p', {
      staticClass: "now-price"
    }, [_vm._v("￥"), _c('em', [_vm._v(_vm._s(item.price))]), _c('span', {
      staticClass: "date-unit"
    }, [_vm._v(_vm._s(item.dateUnit))])]), _vm._v(" "), (item.originPrice > item.price) ? _c('span', {
      staticClass: "original"
    }, [_vm._v("原价￥" + _vm._s(item.originPrice))]) : _c('span', {
      staticClass: "original-icon"
    }), _vm._v(" "), (item.discount) ? _c('span', {
      staticClass: "price-discount"
    }, [_vm._v(_vm._s(item.discount))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "dotted-line"
    }), _vm._v(" "), _c('p', {
      staticClass: "enjoy-privileges"
    }, [_vm._v(_vm._s(item.privilegesText))])])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "tit pay-type-tit"
  }, [_vm._v("请扫码支付：")]), _vm._v(" "), _c('div', {
    staticClass: "pay-center"
  }, [_c('div', {
    staticClass: "pay-qrcode"
  }, [_c('div', {
    attrs: {
      "id": "payqrcode"
    }
  }), _vm._v(" "), (_vm.expire) ? _c('div', {
    staticClass: "refresh-code",
    on: {
      "click": function($event) {
        return _vm.refreshCode()
      }
    }
  }, [_c('div', {
    staticClass: "refresh-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "refresh-text"
  }, [_vm._v("点击刷新")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pay-info"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discountMoney > 0),
      expression: "discountMoney > 0"
    }],
    staticClass: "discount-txt"
  }, [_c('span', [_vm._v("折扣:")]), _vm._v(" "), _c('span', [_vm._v("已优惠" + _vm._s(_vm.discountMoney) + "元")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discountMoney > 0),
      expression: "discountMoney > 0"
    }],
    staticClass: "dotted-line"
  }), _vm._v(" "), _c('p', {
    staticClass: "discount-coupun"
  }), _vm._v(" "), _c('p', {
    staticClass: "meal-price"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.showPrice) + ".00")])]), _vm._v(" "), _c('p', {
    staticClass: "pay-type"
  }, [_c('i', {
    staticClass: "pay pay-wx"
  }), _vm._v(" "), _c('i', {
    staticClass: "pay pay-alipay"
  }), _vm._v(" "), _c('span', {
    staticClass: "pay-text"
  }, [_vm._v("均可扫码支付")])]), _vm._v(" "), _c('p', {
    staticClass: "vip-agreement"
  }, [_vm._v("\n\t\t\t\t\t支付即表示同意\n\t\t\t\t\t《"), _c('span', {
    staticClass: "argument",
    on: {
      "click": _vm.showArgument
    }
  }, [_vm._v("会员用户协议")]), _vm._v("》\n\t\t\t\t")])])])]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "formid",
      "name": "form1",
      "method": "post",
      "target": "_self",
      "action": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "starttime",
      "id": "starttime",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "endtime",
      "id": "endtime",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyAccountId",
      "id": "buyAccountId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "merId",
      "id": "merId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderId",
      "id": "orderId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderMoney",
      "id": "orderMoney",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "isBill",
      "id": "isBill",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "productName",
      "id": "productName",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "productDesc",
      "id": "productDesc",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "returnUrl",
      "id": "returnUrl",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "notifyUrl",
      "id": "notifyUrl",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "sign",
      "id": "sign",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "platfrom",
      "id": "platfrom",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "payfrom",
      "id": "payfrom",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "wapbanklist",
      "id": "wapbanklist",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "balancePaid",
      "id": "balancePaid",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "resumeTag",
      "id": "resumeTag",
      "value": "self_resume"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "accountType",
      "id": "accountType",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "balanceType",
      "id": "balanceType",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "IAPProductID",
      "id": "IAPProductID",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyAccountId",
      "id": "buyAccountId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "extensionInfo",
      "id": "extensionInfo"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cityId",
      "id": "cityId",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "channelId",
      "id": "channelId",
      "value": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-242a3003"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/BuyDialog.vue
// module id = brQr
// module chunks = 1